module.exports = __webpack_public_path__ + "static/media/ic-doc-pdf.7c4383e8.svg";